import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { saveRedirectPath } from '../../utils/authUtils';

const ProtectedRoute = () => {
  const { currentUser, loading } = useContext(AuthContext);
  const location = useLocation();

  // If authentication is still loading, don't redirect yet
  if (loading) {
    // Return null to avoid rendering anything during loading
    return null;
  }

  // If user is not authenticated, redirect to welcome page for root URL, login page for others
  if (!currentUser) {
    // For non-root paths, save for redirect after login
    if (location.pathname !== '/' && location.pathname !== '/home') {
      console.log('ProtectedRoute: Saving path for redirect:', location.pathname);
      saveRedirectPath(location.pathname);
    }
    
    // Redirect to welcome page for root URL, login page for others
    const redirectTo = location.pathname === '/' || location.pathname === '/home' ? '/welcome' : '/login';
    
    // Use replace: true to avoid adding to history stack
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // If user is authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute; 